import React from 'react'
import './App.css';
import Navibar from './Components/Pages/Navigation/Navibar';
import { Route, Routes } from 'react-router-dom';
import Homepage from './Components/Pages/Main/Homepage';
import Footer from './Components/Pages/Navigation/Footer';
import BoardOfDirectors from './Components/Pages/Hr/BoardOfDirectors';
import AccountComittee from './Components/Pages/Hr/AccountComittee';
import AdvisoryBoard from './Components/Pages/Hr/AdvisoryBoard';
import OtherSubCommittee from './Components/Pages/Hr/OtherSubCommittee';
import BranchesPage from './Components/Pages/Main/BranchesPage';
import Branch1 from './Components/Pages/Branches/Branch1';
import Branch2 from './Components/Pages/Branches/Branch2';
import CompulsorySaving from './Components/Pages/SavingService/CompulsorySaving';
import AaishikSaving from './Components/Pages/SavingService/AaishikSaving';
import DailySaving from './Components/Pages/SavingService/DailySaving';
import ChildSaving from './Components/Pages/SavingService/ChildSaving';
import SavingAll from './Components/Pages/SavingService/SavingAll';
import CreditAll from './Components/Pages/CreditService/CreditAll';
import Branch3 from './Components/Pages/Branches/Branch3';
import NaariSaving from './Components/Pages/SavingService/NaariSaving';
import JestaNagarikSaving from './Components/Pages/SavingService/JestaNagarikSaving';
import HealthSaving from './Components/Pages/SavingService/HealthSaving';
import AabadhikSaving from './Components/Pages/SavingService/AabadhikSaving';
import AkshayaSaving from './Components/Pages/SavingService/AkshayaSaving';
import FutureSaving from './Components/Pages/SavingService/FutureSaving';
import FestivalSaving from './Components/Pages/SavingService/FestivalSaving';
import KramikSaving from './Components/Pages/SavingService/KramikSaving';
import LoanPaymentSaving from './Components/Pages/SavingService/LoanPaymentSaving';
import PratifalSaving from './Components/Pages/SavingService/PratifalSaving';
import GeneralAgricultureLoan from './Components/Pages/CreditService/GeneralAgricultureLoan';
import ByabashikAgricultureLoan from './Components/Pages/CreditService/ByabashikAgricultureLoan';
import BusinessLoan from './Components/Pages/CreditService/BusinessLoan';
import HomeLoan from './Components/Pages/CreditService/HomeLoan';
import LandHomeLoan from './Components/Pages/CreditService/LandHomeLoan';
import ForeignLoan from './Components/Pages/CreditService/ForeignLoan';
import EducationLoan from './Components/Pages/CreditService/EducationLoan';
import VehicleLoan from './Components/Pages/CreditService/VehicleLoan';
import SamajikSanskarLoan from './Components/Pages/CreditService/SamajikSanskarLoan';
import LaghuUdyamLoan from './Components/Pages/CreditService/LaghuUdyamLoan';
import LaghuBittiyaLoan from './Components/Pages/CreditService/LaghuBittiyaLoan';
import AayaArjanLoan from './Components/Pages/CreditService/AayaArjanLoan';
import AakasmikLoan from './Components/Pages/CreditService/AakasmikLoan';
import Parikalpana from './Components/Pages/AboutUs/Parikalpana';
import Mission from './Components/Pages/AboutUs/Mission';
import Objectives from './Components/Pages/AboutUs/Objectives';
import Joinings from './Components/Pages/AboutUs/Joinings';
import Pristabhumi from './Components/Pages/AboutUs/Pristabhumi';
import Calendar from './Components/Pages/Calendar/Calendar';
import Staffs from './Components/Pages/Hr/Staffs';
import CooperativeAwards from './Components/Pages/CoopAwards/CooperativeAwards';
import CoopGallery from './Components/Pages/Gallery/CoopGallery';
import FormerBODs from './Components/Pages/Hr/FormerBODs';
import OtherMemberServices from './Components/Pages/Services/OtherMemberServices';
import SadasyaSamman from './Components/Pages/Services/SadasyaSamman';
import SocioServiceAll from './Components/Pages/SocialService/SocioServiceAll';
import SadasyaSikshya from './Components/Pages/SocialService/SadasyaSikshya';
import Membership from './Components/Pages/Membership/Membership';
import YearlyPratibedan from './Components/Pages/Pratibedan/YearlyPratibedan';
import MonthlyPratibedan from './Components/Pages/Pratibedan/MonthlyPratibedan';
import ContactUs from './Components/Pages/ContactUs/ContactUs';
import NibartamanKaryaSamiti from './Components/Pages/Hr/NibartamanKaryaSamiti';
import SabikkaSantha from './Components/Pages/Hr/SabikkaSantha';
import PrastabitKaryasamiti from './Components/Pages/Hr/PrastabitKaryasamiti';
import PEARLS from './Components/Pages/Pratibedan/PEARLS';
import MobileBankingService from './Components/Pages/Services/MobileBankingService';

const App = () => {
  return (
    <>

      <nav>
        <Navibar />
      </nav>

      <main>
        <Routes>

          {/* home route */}
          <Route exact path='/' element={<Homepage />} />

          {/* hr routes */}
          <Route exact path='/hr/bod-members' element={<BoardOfDirectors />} />
          <Route exact path='/hr/supervisory-committee' element={<AccountComittee />} />
          <Route exact path='/hr/advisory-board' element={<AdvisoryBoard />} />
          <Route exact path='/hr/other-subcommittee' element={<OtherSubCommittee />} />
          <Route exact path='/hr/staffs' element={<Staffs />} />
          <Route exact path='/hr/FBODS' element={<FormerBODs />} />
          <Route exact path='/FormerBOD/nibartaman-karya-samiti' element={<NibartamanKaryaSamiti />} />
          <Route exact path='/FormerBOD/sabikka-adhyakshya' element={<SabikkaSantha />} />
          <Route exact path='/FormerBOD/prastabik-karyasamiti' element={<PrastabitKaryasamiti />} />
          <Route exact path='/branches/all' element={
            <div className='main'>
              <div className='left-fixed'></div>
              <div className='container'>
                <BranchesPage />
              </div>
              <div className='right-fixed'></div>
            </div>
          } />

          {/* branches routes */}
          <Route exact path='/branches/sunderpur-service-center' element={<Branch1 />} />
          <Route exact path='/branches/dulari-service-center' element={<Branch2 />} />
          <Route exact path='/branches/biratchowk-service-center' element={<Branch3 />} />

          {/* saving services routes */}
          <Route exact path='/service/saving-service' element={<div className='main'>
            <div className='left-fixed'></div>
            <div className='container'>
              <SavingAll />
            </div>
            <div className='right-fixed'></div>
          </div>}>
          </Route>
          <Route path='/service/saving-service/compulsory-saving' element={<CompulsorySaving />} />
          <Route path='/service/saving-service/aichik-saving' element={<AaishikSaving />} />
          <Route path='/service/saving-service/daily-saving' element={<DailySaving />} />
          <Route path='/service/saving-service/child-saving' element={<ChildSaving />} />
          <Route path='/service/saving-service/naari-saving' element={<NaariSaving />} />
          <Route path='/service/saving-service/jesta-nagarik-saving' element={<JestaNagarikSaving />} />
          <Route path='/service/saving-service/health-saving' element={<HealthSaving />} />
          <Route path='/service/saving-service/aabadhik-saving' element={<AabadhikSaving />} />
          <Route path='/service/saving-service/akshaya-saving' element={<AkshayaSaving />} />
          <Route path='/service/saving-service/future-saving' element={<FutureSaving />} />
          <Route path='/service/saving-service/festival-saving' element={<FestivalSaving />} />
          <Route path='/service/saving-service/kramik-saving' element={<KramikSaving />} />
          <Route path='/service/saving-service/loanpayment-saving' element={<LoanPaymentSaving />} />
          <Route path='/service/saving-service/pratifal-saving' element={<PratifalSaving />} />

          {/* credit services routes */}
          <Route exact path='/service/loan-service' element={
            <div className='main'>
              <div className='left-fixed'></div>
              <div className='container'>
                <CreditAll />
              </div>
              <div className='right-fixed'></div>
            </div>
          } />
          <Route path='/service/loan-service/general-agriculture-loan' element={<GeneralAgricultureLoan />} />
          <Route path='/service/loan-service/byabasahik-agriculture-loan' element={<ByabashikAgricultureLoan />} />
          <Route path='/service/loan-service/business-loan' element={<BusinessLoan />} />
          <Route path='/service/loan-service/home-loan' element={<HomeLoan />} />
          <Route path='/service/loan-service/land-loan' element={<LandHomeLoan />} />
          <Route path='/service/loan-service/foreign-loan' element={<ForeignLoan />} />
          <Route path='/service/loan-service/education-loan' element={<EducationLoan />} />
          <Route path='/service/loan-service/vehicle-loan' element={<VehicleLoan />} />
          <Route path='/service/loan-service/samajik-sanskar-loan' element={<SamajikSanskarLoan />} />
          <Route path='/service/loan-service/laghu-udyam-loan' element={<LaghuUdyamLoan />} />
          <Route path='/service/loan-service/laghu-bittiya-loan' element={<LaghuBittiyaLoan />} />
          <Route path='/service/loan-service/aaya-arjan-loan' element={<AayaArjanLoan />} />
          <Route path='/service/loan-service/aakasmik-loan' element={<AakasmikLoan />} />

          {/* About us routes */}
          <Route path='/aboutus/home' element={<Pristabhumi />} />
          <Route path='/aboutus/parikalpana' element={<Parikalpana />} />
          <Route path='/aboutus/dheya' element={<Mission />} />
          <Route path='/aboutus/objectives' element={<Objectives />} />
          <Route path='/aboutus/joining' element={<Joinings />} />

          {/* Calendar route */}
          <Route path='/calendar' element={<Calendar />} />

          {/* Awards route */}
          <Route exact path='/award' element={
            <div className='main'>
              <div className='left-fixed'></div>
              <div className='container'>
                <CooperativeAwards />
              </div>
              <div className='right-fixed'></div>
            </div>
          } />

          {/* Gallery route */}
          <Route path='/gallery' element={<CoopGallery />} />

          {/* Services Route */}
          <Route path='/service/other-member-sevice' element={<OtherMemberServices />} />
          <Route path='/service/sadasya-samman-program' element={<SadasyaSamman />} />
          <Route path='/service/mobile-banking-service' element={<MobileBankingService />} />

          {/* Social Service Route */}
          <Route path='/socialservice' element={<div className='main'>
            <div className='left-fixed'></div>
            <div className='container'>
              <SocioServiceAll />
            </div>
            <div className='right-fixed'></div>
          </div>} />
          <Route path='/socialservice/sadashya-sikshya' element={<SadasyaSikshya />} />

          {/* Membership Route */}
          <Route path='/membership' element={<Membership />} />

          {/* Pratibedan Route */}
          <Route path='/report/yearly' element={<YearlyPratibedan />} />
          <Route path='/report/monthly' element={<MonthlyPratibedan />} />
          <Route path='/report/PEARLS' element={<PEARLS />} />

          {/* contact form route */}
          <Route path='/suggestion' element={<ContactUs />} />

          {/* other routes */}
          <Route path='*' element={<div style={{ display: 'flex', justifyContent: 'center', }}><p><b>404 PAGE NOT FOUND !</b></p></div>} />

        </Routes>
      </main>

      <footer>
        <Footer />
      </footer>

    </>
  )
}

export default App